import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, CheckboxField, CheckboxFieldWithInput, } from '@pinwheel/origami';
import { useDispatch } from 'react-redux';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { selectIncomeSources, selectPaymentMethods, setPaymentMethods, } from '../../state/slices/slice-wizard';
import { useAppSelector } from '../../state';
import BaseWizardScreen from './BaseWizardScreen';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
export default function WizardPaymentMethods() {
    var navigate = useLinkNavigate();
    var dispatch = useDispatch();
    var getLocalizedString = useGetLocalizedString();
    var paymentMethods = useAppSelector(selectPaymentMethods);
    var incomeSources = useAppSelector(selectIncomeSources);
    var methodSelected = useCallback(function (method) {
        var _a;
        return (((_a = paymentMethods.paymentMethods) === null || _a === void 0 ? void 0 : _a.find(function (val) { return val === method; })) !==
            undefined);
    }, [paymentMethods]);
    var _a = useState(methodSelected('cash')), checkboxCash = _a[0], setCheckboxCash = _a[1];
    var _b = useState(methodSelected('direct-deposit')), checkboxDirectDeposit = _b[0], setCheckboxDirectDeposit = _b[1];
    var _c = useState(methodSelected('check')), checkboxCheck = _c[0], setCheckboxCheck = _c[1];
    var _d = useState(methodSelected('debit-card')), checkboxDebitCard = _d[0], setCheckboxDebitCard = _d[1];
    var _e = useState(methodSelected('pay-card')), checkboxPayCard = _e[0], setCheckboxPayCard = _e[1];
    var _f = useState(function () {
        if (!paymentMethods) {
            return false;
        }
        return Boolean(paymentMethods.otherPaymentMethod);
    }), checkboxOther = _f[0], setCheckboxOther = _f[1];
    var _g = useState(paymentMethods.otherPaymentMethod), checkboxOtherVal = _g[0], setCheckboxOtherVal = _g[1];
    var determineRoute = useMemo(function () {
        if (incomeSources.incomeSources.find(function (is) { return is === 'w2'; })) {
            return '/wizard/income-source-w2';
        }
        if (incomeSources.incomeSources.find(function (is) { return is === '1099'; })) {
            return '/wizard/income-source-1099';
        }
        if (incomeSources.incomeSources.find(function (is) { return is === 'benefits'; })) {
            return '/wizard/income-source-benefits';
        }
        return '/search/search';
    }, [incomeSources]);
    var _h = useState(paymentMethods), tempPaymentMethodsState = _h[0], setTempPaymentMethodsState = _h[1];
    useEffect(function () {
        var paymentMethodsSelected = [];
        if (checkboxCash) {
            paymentMethodsSelected.push('cash');
        }
        if (checkboxDirectDeposit) {
            paymentMethodsSelected.push('direct-deposit');
        }
        if (checkboxCheck) {
            paymentMethodsSelected.push('check');
        }
        if (checkboxDebitCard) {
            paymentMethodsSelected.push('debit-card');
        }
        if (checkboxPayCard) {
            paymentMethodsSelected.push('pay-card');
        }
        var updatedState = {
            visited: true,
            paymentMethods: paymentMethodsSelected,
            otherPaymentMethod: checkboxOtherVal,
        };
        setTempPaymentMethodsState(updatedState);
    }, [
        checkboxCash,
        checkboxDirectDeposit,
        checkboxCheck,
        checkboxDebitCard,
        checkboxPayCard,
        checkboxOther,
        checkboxOtherVal,
    ]);
    var body = useMemo(function () { return (React.createElement(React.Fragment, null,
        React.createElement(CheckboxField, { checked: checkboxDirectDeposit, onChange: setCheckboxDirectDeposit, label: getLocalizedString('WIZARD_PAYMENT_METHODS_CHECKBOX_DIRECT_DEPOSIT'), "data-testid": "direct-deposit" }),
        React.createElement(CheckboxField, { checked: checkboxCheck, onChange: setCheckboxCheck, label: getLocalizedString('WIZARD_PAYMENT_METHODS_CHECKBOX_CHECK'), "data-testid": "check" }),
        React.createElement(CheckboxField, { checked: checkboxDebitCard, onChange: setCheckboxDebitCard, label: getLocalizedString('WIZARD_PAYMENT_METHODS_CHECKBOX_DEBIT_CARD'), "data-testid": "debit-card" }),
        React.createElement(CheckboxField, { checked: checkboxCash, onChange: setCheckboxCash, label: getLocalizedString('WIZARD_PAYMENT_METHODS_CHECKBOX_CASH'), "data-testid": "cash" }),
        React.createElement(CheckboxField, { checked: checkboxPayCard, onChange: setCheckboxPayCard, label: getLocalizedString('WIZARD_PAYMENT_METHODS_CHECKBOX_PAY_CARD'), "data-testid": "pay-card" }),
        React.createElement(CheckboxFieldWithInput, { checked: checkboxOther, label: getLocalizedString('OTHER'), placeholder: getLocalizedString('WIZARD_PAYMENT_METHODS_CHECKBOX_OTHER_PLACEHOLDER'), onChange: setCheckboxOther, onInputChange: setCheckboxOtherVal, "data-testid": "other" }))); }, [
        checkboxOther,
        checkboxPayCard,
        checkboxCash,
        checkboxDebitCard,
        checkboxCheck,
        checkboxDirectDeposit,
        getLocalizedString,
    ]);
    var button = useMemo(function () {
        var _a;
        return (React.createElement(Button, { dataTestId: "Continue", onClick: function () {
                if (tempPaymentMethodsState) {
                    dispatch(setPaymentMethods(tempPaymentMethodsState));
                }
                return navigate(determineRoute);
            }, disabled: 
            // No temp state
            !tempPaymentMethodsState ||
                // No payment methods selected and no "Other" value populated
                (((_a = tempPaymentMethodsState.paymentMethods) === null || _a === void 0 ? void 0 : _a.length) === 0 &&
                    !(checkboxOther && checkboxOtherVal)) ||
                // Other is checked but the text box is not
                (checkboxOther && !checkboxOtherVal) }, getLocalizedString('CONTINUE')));
    }, [
        tempPaymentMethodsState,
        checkboxOther,
        checkboxOtherVal,
        determineRoute,
        dispatch,
        navigate,
        getLocalizedString,
    ]);
    return (React.createElement(BaseWizardScreen, { dataTestId: "Wizard-PaymentMethods", titleText: getLocalizedString('WIZARD_PAYMENT_METHODS_TITLE'), subtitleText: getLocalizedString('CHECK_ALL_THAT_APPLY'), buttons: button }, body));
}
